import { useRouteMatch } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { getBaseUrl } from 'services/util';
import { Button } from 'react-bootstrap';
import cx from 'classnames';

import { nudgeTriggered } from 'actions/workspace';

import styles from "./nudges.module.scss";

export default function JourneyNudge({storyboard, workspace}) {
    const dispatch = useDispatch();
    let { url } = useRouteMatch();
    let baseUrl = getBaseUrl(url);

    const handleNavigate = () => {
      const request = { 'journeyNudge': true }
        if (baseUrl && storyboard) {
            dispatch(nudgeTriggered(workspace?.id, request));
            const win = window.open(`${baseUrl}/storyboards/${storyboard?.id}/journey`, "_blank");
            if (win) win.focus();
        }
    }

    const handleSkip = () => {
      const request = { 'journeyNudge': true }
        dispatch(nudgeTriggered(workspace?.id, request));
    }

  return (
    <div className={styles.nudge}>
      <header className={styles.headerContainer}>
        <div className={styles.header}>Show Readers What's Next</div>
        <div className={styles.description}>Use Journeys to connect assets and keep them exploring.</div>
      </header>
      <div className={styles.actionContainer}>
        <Button variant="secondary" className={styles.skip} onClick={handleSkip}>
          Skip
        </Button>
        <Button variant="primary" className={styles.create} onClick={handleNavigate}>
          Create Journey <i className={cx(styles.icon, "cleverstory-url")} />
        </Button>
      </div>
      <div className={styles.videoContainer}>
        <video className={styles.setupVideo} loop autoPlay playsInline muted>
          <source src="/images/journeySetup.mp4" type="video/mp4" />
        </video>
      </div>
    </div>
  );
}